export default function({ $sentry, $auth }) {
  if (!$auth.loggedIn) { return }

  $sentry.setUser({
    id: $auth.user.id,
    email: $auth.user.email,
    fset: $auth.user.fset?.name,
    srv: $auth.user.meta.srv
  })
}
